<template>
  <div>
    <div class="coverShow" v-show="viseable">
      <div class="container-gj" @click="handleCloseClick">
        <div class="container-gd">
          <div class="header-div">
            <div
              style="
                font-size: 18px;
                font-weight: 600;
                color: #2b2f36;
                line-height: 24px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
            >
              {{ title }}
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              mode=""
              @click="cancleClick"
              style="width: 13px; height: 13px; position: absolute; right: 20px"
            />
          </div>
          <div v-if="type === 0" class="body-div">
            <div class="center-content">
              <input
                placeholder-class="input-placeholder"
                type="text"
                v-model="content"
                placeholder="请输入"
                @input="onInputLimit"
              />
            </div>
          </div>
          <div v-if="type === 1" class="center-content">
            <div
              style="width: 100%; box-sizing: border-box; background: #f4f4f4"
            >
              <textarea
                v-model.lazy="content"
                maxlength="500"
                rows="12"
                :focus="focus"
                @focus="onTextareaFocus"
                @blur="onTextareaBlur"
                @input="onTextareaInput"
                placeholder="添加选项，一行一个，最多30个例如：分公司、部门、职位等每行可输入最多12个字符"
                style="
                  resize: none;
                  padding: 10px;
                  border-radius: 4px;
                  box-sizing: border-box;
                "
              ></textarea>
            </div>
            <!-- <div
              class="textareaPlaceholder"
              v-show="content === '' && !focus"
              @click="focusTextarea"
            >
              添加选项，一行一个，最多30个
              <div>例如：分公司、部门、职位等</div>
              <div>每行可输入最多12个字符</div>
            </div> -->
          </div>
          <div v-if="type === 2" class="body-div">
            <div class="zz">
              <div>文本格式：</div>
              <el-select
                v-model="validateValue"
                placeholder="请选择"
                style="
                  width: 214px;
                  border: 1px solid #e7e7e7;
                  border-radius: 4px;
                "
              >
                <el-option
                  v-for="item in validateArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="no-repeat">
              <div>
                <div class="no-title">记录唯一性 不可以重复</div>
                <div class="no-tips">例如学号 工号只能一个投票者使用。</div>
              </div>
              <el-switch
                v-model="unique"
                active-color="#59D27B"
                :active-value="'1'"
                :inactive-value="'0'"
              >
              </el-switch>
            </div>
          </div>
          <div class="btn-div">
            <div class="cancle" @click="cancleClick">取消</div>
            <div class="confirm" @click="confirmClick">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 2,
    },
    aContent: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "提示",
    },
  },
  emits: ["close", "confirm"],
  data() {
    return {
      viseable: false,
      validateValue: "0",
      validateArr: [
        {
          label: "不限格式",
          value: "0",
        },
        {
          label: "仅中文",
          value: "1",
        },
        {
          label: "仅英文",
          value: "2",
        },
        {
          label: "仅数字",
          value: "3",
        },
        {
          label: "英文+数字",
          value: "4",
        },
        {
          label: "中文+数字",
          value: "5",
        },
        {
          label: "中文+英文",
          value: "6",
        },
      ],
      unique: "0",
      content: "",
      focus: false,
    };
  },
  methods: {
    handleCloseClick() {
      // this.$emit("close");
    },
    onTextareaFocus() {
      this.focus = true;
    },
    onTextareaBlur() {
      this.focus = false;
    },
    onTextareaInput(e) {
      const lines = e.target.value.split("\n");
      let isValid = true;

      // 检查是否有行超过12个字符
      lines.forEach((line) => {
        if (line.length > 12) {
          isValid = false;
        }
      });

      // 如果无效，回退到上一次合法值
      if (!isValid) {
        e.target.value = this.text;
      } else {
        this.text = e.target.value;
      }
      // let lines = e.target.value.split("\n");
      // lines = lines.map((line) => line.slice(0, 12));
      // if (lines.length > 30) {
      //   lines = lines.slice(0, 30);
      // }
      // this.content = lines.join("\n");
    },
    cancleClick() {
      console.log("dqwmnwtwqfqwftyqw");

      this.$emit("close");
      this.content = "";
    },
    confirmClick() {
      if (this.type === 2) {
        this.$emit(
          "confirm",
          JSON.stringify({
            format: this.validateValue,
            unique: this.unique,
          })
        );
      } else {
        this.$emit("confirm", this.content);
        this.content = "";
      }
    },
    onInputLimit() {
      // if (this.content.length > 500) {
      //   this.content = this.content.slice(0, 500);
      // }
    },
    // uniqueSwitch(e) {
    //   this.unique = e.detail.value;
    // },
    // bindvalidatePickerChange(e) {
    //   state.validateIndex = e.detail.value;
    //   state.content = state.validateArr[state.validateIndex].value;
    // },
  },
  watch: {
    showDialog(newVal) {
      this.viseable = newVal;
      this.validateValue = "0";
    },
    aContent(newVal) {
      this.content = newVal;
      console.log("newVal111111111111111111111", newVal, this.content);
      if (this.type === 2) {
        this.validateValue = JSON.parse(newVal).format;
        this.unique = JSON.parse(newVal).unique;
      }
    },
  },
};
</script>

<style scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 420px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  overflow: hidden;
  /* overflow-y: auto; */
}

.btn-div {
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: center;
  /* padding-bottom: 10rpx; */
}

.cancle {
  /* position: absolute; */
  width: 50%;
  height: 46px;
  line-height: 46px;
  left: 0;
  bottom: 0;
  text-align: center;
  border-top: 1px solid #e4e4e4;
  font-size: 17px;
  font-weight: 600;
  color: #3a60ff;
}

.confirm {
  /* position: absolute; */
  width: 50%;
  height: 46px;
  line-height: 46px;
  right: 0;
  bottom: 0;
  text-align: center;
  border-top: 1px solid #e4e4e4;
  background: #3a60ff;
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  /* margin-left: 15px; */
}

.zz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
  padding-right: 10px;

  div {
    color: #555555;
    font-size: 15px;
  }
}

/* .zz-picker{
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding-left: 10px;
      padding-right: 10px;
      width: 428rpx;
      height: 88rpx;
      background: #f4f4f4;
      border-radius: 10rpx;
      image{
          width: 40rpx;
          height: 40rpx;
      }
  } */

.no-repeat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  height: 80px;
}

.no-title {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #555555;
}

.no-tips {
  font-size: 13px;
  text-align: left;
  color: #7c838e;
}

.center-content {
  width: 92%;
  margin: 10px auto;
  input {
    width: 100%;
    height: 45px;
    background: #f4f4f4;
    border: 2rpx solid #dcdde0;
    border-radius: 4px;
    box-sizing: border-box;
    padding-left: 10px;
  }

  textarea {
    width: 100%;
    height: 500rpx;
    background: #f4f4f4;
    border: 2rpx solid #dcdde0;
    border-radius: 8rpx;
    box-sizing: border-box;
    overflow-y: auto;
  }
}

.header-div {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/PopupInput/PopupInput.vue